import React, {useMemo, useState} from "react";

export default function Alert({title, messages, theme, hideDays=0}) {
    const[showAlert, setShowAlert] = useState(getCookie(title.replace(/ /g,"_")+'_alert') ? false : true);

    const alertClass = "alert alert-dismissible d-flex flex-column flex-sm-row py-5 px-2 mb-10 " + theme;
    const rows = useMemo(() => {
        const rows = messages.map((node, i) =>
            (<span key={i}>
                {node}
                <br/>
            </span>)
        )
        return rows;
    }, [messages]);

    // On dismiss
    const _onAlertClose = (e) => {
        e.target.closest('.alert').classList.add("d-none");
        setCookie(title.replace(/ /g,"_")+'_alert', 1, hideDays);
        setShowAlert(false);
    };

    return showAlert && <div className={alertClass}>
        {/*<i className="ki-duotone ki-notification-bing fs-2hx text-primary me-2 mb-5 mb-sm-0">*/}
        {/*    <span className="path1"></span><span className="path2"></span><span className="path3"></span>*/}
        {/*</i>*/}
        <i className="ki-duotone ki-information-2 fs-2hx text-primary me-2 mb-5 mb-sm-0">
            <span className="path1"></span>
            <span className="path2"></span>
            <span className="path3"></span>
        </i>

        <div className="d-flex flex-column pe-0 pe-sm-2">
            <h4 className="fw-semibold">{title}</h4>
            {rows}
        </div>
        <button type="button" className="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto" data-bs-dismiss="alert" onClick={(e) => {_onAlertClose(e)}}>
            <i className="ki-duotone ki-cross fs-1 text-primary"><span className="path1"></span><span className="path2"></span></i>
        </button>
    </div>
}